import { createContext, useContext, useEffect, useState, ReactNode } from 'react'
import { supabase } from '@/lib/supabase/client'
import { Company } from '@/types/company'
import { useAuth } from './AuthContext'

export interface CompanyContextType {
  company: Company | null
  isLoading: boolean
  fetchCompany: () => Promise<void>
}

export const CompanyContext = createContext<CompanyContextType | undefined>(undefined)

export function useCompany(): CompanyContextType {
  const context = useContext(CompanyContext)
  if (context === undefined) {
    throw new Error('useCompany deve ser usado dentro de um CompanyProvider')
  }
  return context
}

export function CompanyProvider({ children }: { children: ReactNode }) {
  const [company, setCompany] = useState<Company | null>(null)
  const [isLoading, setIsLoading] = useState(true)
  // Usa a instância singleton do Supabase
  const { user } = useAuth()

  const fetchCompany = async () => {
    // Remover toda a lógica de busca de empresa/company, especialmente qualquer referência a current_company_id, para eliminar dependências do antigo CRM.
  }

  useEffect(() => {
    fetchCompany()
  }, [user])

  return (
    <CompanyContext.Provider value={{ company, isLoading, fetchCompany }}>
      {children}
    </CompanyContext.Provider>
  )
} 